import { ChangeEvent, useContext, useEffect, useRef, useState } from 'react';
import api from '~/services/api';
import Upload from '~/services/upload';
import './styles.css';
import Button from "~/components/Parts/Forms/Button"

// Contexts
import { GeneralContext, MixPanelContext, ModalContext } from '~/contexts';

// Form
import FormBill from './Form';

export const useSingleBills = () => {
    const [ready, setReady]           = useState<Boolean>();
    const [bills, setBills]           = useState<any[]>([]);
    const [filesLoad, setFilesLoads]  = useState<any>(null);
    const [uploadFile, setUploadFile] = useState(false);
    const file                        = useRef<HTMLInputElement>(null);

    // Context
    const Modal         = useContext(ModalContext);
    const {buttonClick} = useContext(MixPanelContext);
    const {user, unit}  = useContext(GeneralContext);

    const isAdmin       = user.role === "admin" ? true : false

    function delBill (id: number) {
        buttonClick(user.id, 'Contas de energia', `Exclusão de fatura`)

        api.delete(`/bills/${id}`, {
            headers: { Authorization: user.token }
        }).then(resp => {
            Modal.setModalOpen(false)
            setReady(false);
        })
    }

    function onChange(event: ChangeEvent<HTMLInputElement>) {
        if (event.currentTarget.files && event.currentTarget.files.length>0) {
            setUploadFile(true)
            let err = _validatorExtention(event?.currentTarget.files);
            let item: any = {};

            if (!err) {
                item['id']            = event.currentTarget.files[0].lastModified;
                item['status']        = 'Em andamento';
                item['file_name']     = event.currentTarget.files[0].name;
                item['file_complete'] = event.currentTarget.files;

                setFilesLoads({...filesLoad, ...item});

                Upload.sendFile(user, unit, event.currentTarget.files[0])
                .then(resp => {
                    setUploadFile(false)
                    if (resp.valid) {
                        openModalBillReceived()
                    } else {
                        openModalUploadError()
                    }
                }).catch(err => {
                    setUploadFile(false)
                    console.log(err)
                    openModalUploadError()
                })
            } else {
                setUploadFile(false)
                alert('Extensão inválida')
            }
        }
    }

    function _validatorExtention (files: FileList) {
        let _validFileExtensions = [".pdf"];
        let err = false;
        const extname = (fileName: string) => {
            const idx = String(fileName || '').lastIndexOf('.');
            return idx >= 0 ? String(fileName).slice(idx).toLowerCase() : '';
        };
        Array.from(files).forEach(file => {
            let ext = extname(file.name);
            if (!_validFileExtensions.includes(ext)) err = true;
        })
        return err;
    }

    function openModalInfoBill(){
        let body
        body = <div className="modal_file">
            <p><strong>Dados incompletos </strong><br/><br/>Problema na bandeira tarifária ou tarifa, isso pode gerar problemas no relatório de economia. <br/><br/> Nossa equipe já foi notificada e em breve o relatório de economia estará disponível.</p>
            </div>
        setUploadFile(false)
        Modal.setModalTitle('Problema ao gerar relatorio de economia')
        Modal.setModalBody(body)
        Modal.setModalOpen(true)
    }

    function openModalBillReceived () {
        const body = <div className="modal_file">
            <p>Sua fatura chegou para o nosso time. Em breve ela estará disponível na plataforma e avisaremos você por e-mail.</p>
            <div className="button">
                <Button
                    type="button"
                    className="edit"
                    func={() => Modal.setModalOpen(false)}
                    text="Voltar"
                />
            </div>
        </div>

        Modal.setModalTitle('Fatura enviada')
        Modal.setModalBody(body)
        Modal.setModalOpen(true)
    }

    function openModalUploadError () {
        const body = <div className="modal_file">
            <p>Não foi possível enviar sua fatura. Tente novamente em instantes.</p>
            <div className="button">
                <Button
                    type="button"
                    className="edit"
                    func={() => Modal.setModalOpen(false)}
                    text="Voltar"
                />
            </div>
        </div>

        Modal.setModalTitle('Erro ao enviar fatura')
        Modal.setModalBody(body)
        Modal.setModalOpen(true)
    }

    function openModalBill () {
        Modal.setModalOpen(false);
        Modal.setModalClass('mbills');
        Modal.setModalTitle('Cadastro Manual de Fatura')
        Modal.setModalBody(<FormBill setReady={setReady} setErrorModal={openModalInfoBill}/>)
        Modal.setModalOpen(true)
    }

    useEffect(() => {
        !ready && unit && api.get(`bills/${unit.id}`, {
            headers: { Authorization: user.token }
        }).then(resp => {
            setTimeout(() => {
                setBills(resp.data);
                setReady(true);
        }, 1000)
        });
    }, [user, unit, ready]);

    return {
        ready,
        file,
        uploadFile,
        bills,
        delBill,
        onChange,
        openModalBill,
        setReady,
        isAdmin
    }
}
